class ScheduledReportListViewController extends EntityListViewController
{
    static newInstance() : ScheduledReportListViewController {
        let vc = new ScheduledReportListViewController("scheduled-report-list-view");
        vc.initWithResource("layout/scheduledreport/ScheduledReportListView.html");
        return vc;
    }

    private addButton:MUIButton = null;

    reportNamesByID = {};

    viewDidLoad(){
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        this.addButton.setAction(this, function(this:ScheduledReportListViewController){
            this.addScheduledReport();
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.downloadReportNames();
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    private downloadReportNames(){
        let lang = SettingsHelper.sharedInstance().currentSupportedLanguage;
        let predicate = MIOPredicate.predicateWithFormat("report != null and language = '" + lang + "'");
        DBHelper.queryObjectsWithCompletion("ReportLocalized", null, predicate, ["report"], this, function(this:ScheduledReportListViewController, objects){
            for (let index = 0; index < objects.length; index++){
                let rl = objects[index] as ReportLocalized;
                if (rl.report != null) this.reportNamesByID[rl.report.identifier] = rl.name;
            }
            this.tableView.reloadData();
        });
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("ScheduledReportListCell") as ScheduledReportListCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ScheduledReport;
        cell.setItem(item, this.reportNamesByID[item.reportID]);
        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ScheduledReport;
        let vc = ScheduledReportDetailViewController.newInstance();
        vc.item = item;
        this.navigationController.pushViewController(vc, true);
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView:UITableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath);
        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            DBHelper.deleteObjectFromMainContext(item, true);
        }
    }

    get entityName(){
        return 'ScheduledReport';
    }

    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;

        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [
            MIOSortDescriptor.sortDescriptorWithKey("sendTime", true),
            MIOSortDescriptor.sortDescriptorWithKey("title", true)
        ];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("ScheduledReport", sortDescriptors, null);

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    private addScheduledReport(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("NEW_SCHEDULED_REPORT", "NEW SCHEDULED REPORT"), MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME"), MUIAlertViewStyle.Default);
        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
        });
        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('ADD','ADD'), MUIAlertActionStyle.Default, this, function(this:ScheduledReportListViewController){
            let name = avc.textFields[0].text.trim();
            if (name.length == 0) return;

            let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;
            let item = MIOEntityDescription.insertNewObjectForEntityForName("ScheduledReport", moc) as ScheduledReport;
            item.identifier = MIOUUID.UUID().UUIDString;
            item.title = name;
            item.active = true;
            item.format = "xlsx";
            item.period = "yesterday";
            item.recurrence = "daily";
            item.sendTime = "07:00";
            item.weekday = 0;
            item.dayOfMonth = 0;
            moc.save();
        }));
        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','Cancel'), MUIAlertActionStyle.Cancel, this, function(){}));

        this.presentViewController(avc, true);
    }
}
